import { StyledTitle } from "./styles";

export const Title = () => {
  return (
    <StyledTitle>
      <div className="title">
        Rick <span>and</span> Morty
      </div>
      <div className="title middle">
        Rick <span>and</span> Morty
      </div>
      <div className="title bottom">
        Rick <span>and</span> Morty
      </div>
    </StyledTitle>
  );
};

// div.title Rick
// span and
// | Morty
// div.title.middle  Rick
// span and
// | Morty
// div.title.bottom  Rick
// span and
// | Morty
